var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1AAB9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25138 11.9003V7.37495L7.68319 9.95795V11.9003H8.55956V9.77627C8.5595 9.69703 8.54102 9.61889 8.50558 9.54802C8.47015 9.47715 8.41873 9.41549 8.35538 9.36789L4.19344 6.23533C4.11756 6.17832 4.02731 6.14356 3.93279 6.13493C3.83827 6.1263 3.74322 6.14415 3.65828 6.18648C3.57333 6.22881 3.50184 6.29394 3.45181 6.3746C3.40178 6.45525 3.37518 6.54823 3.375 6.64314V11.9003H4.25138ZM13.743 11.9003V7.37495L10.3112 9.95795V11.9003H9.43481V9.77627C9.43481 9.61539 9.51019 9.46408 9.63844 9.36789L13.8009 6.23533C13.8769 6.17829 13.9672 6.14352 14.0617 6.13492C14.1563 6.12631 14.2514 6.14421 14.3364 6.18661C14.4213 6.229 14.4928 6.29422 14.5428 6.37495C14.5928 6.45569 14.6193 6.54875 14.6194 6.6437V11.9008L13.743 11.9003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkr);
export default __webpack_public_path__ + "static/media/mkr.51016845000a2e2ea36c3f8df963d63a.svg";
export { ForwardRef as ReactComponent };